import './App.css';
import './assets/css/style.css';
import { BrowserRouter as Router } from "react-router-dom"
import Routing from './routes';
import 'typeface-roboto';

function App() {
  return (
    <>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routing />
      </Router>
    </>
  );
}

export default App;
